<template>
  <v-main class="ma-0 pa-0">
    <v-card flat class="poker-table" :class="needsAttention()">
      <v-card-text>
        <div v-if="state" class="hand-number">
          <p>
            Hand #{{state.hand_num}}<br />
            BB: ${{getBlinds()}}<br />
            {{ getStatus() }} <br />
            <b>
              {{ getCode() }}{{ mttTableIdBit() }}
              <template v-if="tourneyType()">- {{ tourneyType() }}</template>
            </b><br />
            <template v-if="inMtt()">
              Rebuys: {{ rebuysDone }} / {{ rebuysTotal }}
            </template>
          </p>
        </div>
        <div  v-if="is_poker && state">
          <poker-player v-for="player of state.players"
            :player="player" :key="player.id" :state="state">
          </poker-player>
        </div>
        <div v-if="is_ofc && state">
          <ofc-player :player="state.p1" :state="state" :seat="0" v-if="state.p1">
          </ofc-player>
          <ofc-player :player="state.p2" :state="state" v-if="state.p2" :seat="1">
          </ofc-player>
          <ofc-player :player="state.p3" :state="state" v-if="state.p3" :seat="2">
          </ofc-player>
        </div>
        <board-cards v-if="is_poker && state" :cards="state.board">
        </board-cards>
        <board-pot v-if="is_poker && state" :pots="state.pots" :state="state"></board-pot>
        <chat-panel :name="name"  @send-chat="sendChat"></chat-panel>
        <player-menu :name="name"></player-menu>
      </v-card-text>
    </v-card>
  </v-main>
</template>

<script>

import Player from './PokerPlayer.vue';
import Board from './BoardCards.vue';
import Pot from './PokerPots.vue';
import ChatPanel from './ChatPanel.vue';
import PlayerMenu from './PlayerMenu.vue';
import OfcPlayer from './OfcPlayer.vue';
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    'poker-player': Player,
    'board-cards': Board,
    'board-pot': Pot,
    'chat-panel': ChatPanel,
    'player-menu': PlayerMenu,
    'ofc-player': OfcPlayer,
  },
  props: {
    name: String
  },
  computed: {
    is_ofc() {
      let state = this.accountState(this.name);
      return state && state.settings && state.settings.ofcType;
    },
    is_poker() {
      let state = this.accountState(this.name);
      let settings = state && state.settings;
      return state && settings && (settings.omaha !== undefined || settings.gameTypeId === "cashNL");
    },
    state() {
      return this.accountState(this.name);
    },
    chatAcc() {
      return this.chatAccounts[this.name];
    },
    tourney_state() {
      let acc = this.chatAcc;

      if (!acc) {
        return null;
      }

      // get tourney rebuys info
      for (let el of (acc.tourney_states || [])) {
        if ((''+el.gameCode) === (''+this.getCode())) {
          return el;
        }
      }
      return null;
    },
    ourMttStatus() {
      if (!this.state) { return null; }
      if (!this.state.room) { return null; }

      let pid = this.state.player_id;

      // see if we are in any players or ranking list anywhere
      var lists = [
        (this.state.room.mainRoomDataObject || {}).ranking,
        (this.state.room.mainRoomDataObject || {}).players,
        this.state.room.players,
        this.state.room.ranking,
      ];
      for (let list of lists) {
        if (!list) { continue; }
        for (let ent of list) {
          if (ent.playerId === pid) {
            return ent;
          }
        }
      }

      return null;
    },
    rebuysDone() {
      let ourStatus = this.ourMttStatus;
      if (!ourStatus) {
        return 0;
      }
      return (ourStatus.bought || 1) - 1;
    },
    rebuysTotal() {
      return (this.tourney_state || {}).rebuys_total || '?';
    },
    ...mapGetters([
      "accountState",
    ]),
    ...mapState([
      "chatAccounts",
    ])
  },
  data() {
    return {
    };
  },
  methods: {
    sendChat(text) {
      this.$emit("chat-message", {acc: this.account, text: text})
    },
    getBlinds() {
      if (!this.state || !this.state.settings) {
        return 0.0;
      }

      if (this.tourneyType() && !this.state.settings.bb) {
        return 'N/A';
      }

      let divider = this.state.settings.withDecimal ? 100 : 1;
      return this.state.settings.bb / divider;
    },
    getStatus() {
      if (!this.state || !this.state.room) {
        return '';
      }

      let status = this.state.room.status;

      return status + " (" + (this.state.room.players || []).length + "/" + (this.state.room.settings || {}).maxPlayer + ")";
    },
    getCode() {
      if (!this.state || !this.state.room) {
        return '';
      }
      if (this.state.room.mainRoomDataObject) {
        return this.state.room.mainRoomDataObject.gameCode;
      }
      return this.state.room.gameCode;
    },
    mttTableIdBit() {
      return (this.state && this.state.room && this.state.room.mttTableId !== undefined
                  ? '-' + this.state.room.mttTableId
                  : '');
    },
    inMtt() {
      return this.tourneyType() === 'MTT';
    },
    tourneyType() {
      if (!this.state || !this.state.room) {
        return null;
      }

      if (this.state.room.mainRoomDataObject) {
        return 'MTT';
      }

      let settings = this.state.room.settings;
      if (!settings) {
        return null;
      }
      if (settings.prizePlan === undefined) {
        return null;
      }
      if (settings.rummy) {
        return null;
      }
      if (settings.maxPlayer <= 9) {
        return 'SNG';
      }
      return 'MTT';
    },
    needs_attention() {
      if (!this.state) {
        return '';
      }
      return '';
    },
    getStatePlayer() {
      let pid = this.state.player_id;
      if (!this.state) return null;
      var k;
      if ("p1" in this.state) {
        for (k of ["p1", "p2", "p3"]) {
          let p = this.state[k];
          if (p && p.id === pid) {
            return p
          }
        }
      } else {
        for (k in this.state.players) {
          let p = this.state.players[k];
          if (p && p.id === pid) {
            return p
          }
        }
      }
      return null;
    },
    needsAttention() {
      if (!this.state) {
        return '';
      }
      let p = this.getStatePlayer();
      let s = this.state.settings;
      if (s && s.minStackBB && p && p.stack / s.bb < s.minStackBB) {
        // there is a minimum stack, if we have less then that need to reload
        return 'red lighten-2';
      }
      if (p && p.stack == 0) {
        // when we have 0 stack we need to reload
        return 'red lighten-2';
      }
      return '';
    }
  }
}

</script>

<style scoped>
.poker-table {
  background-image: url('/static/imgs/poker-bg.png');
  height: 680px;
  width: 420px;

  margin: auto;
}

.hand-number {
  display: flex;
  position: absolute;
  top: 150px;
  left: 180px;
  color: white;
}
</style>
